import { useLocation } from "react-router-dom";
export var useLocationState = function () {
    var location = useLocation();
    var state = location.state;
    return state;
};
